export type CommunicationType = 'InitialEstimate' | 'EstimateFollowUp' | 'Invoice' | 'Receipt';

export interface SendCommunicationDto {
  emailAddresses: string[];
  phoneNumbers: string[];
  subject: string;
  emailBody: string;
  smsBody: string;
  communicationType: CommunicationType;
  associatedEstimateId?: number;
  // An invoice or a receipt: the server marks the invoice Sent / its receipt sent.
  associatedInvoiceId?: number;
}

export interface SendCommunicationResponseDto {
  success: boolean;
  emailsSent?: number;
  smsSent?: number;
  errors?: string[];
}

export interface MessageContentResponseDto {
  communicationType: CommunicationType;
  subject: string;
  emailBody: string;
  smsBody: string;
  documentLink: string;
}

export type DocumentType = 'estimate' | 'invoice' | 'work-order' | 'receipt';
export type DeliveryChannel = 'email' | 'sms';

export interface SendCommunicationParams {
  documentType: DocumentType;
  documentId: number;
  recipients: CommunicationRecipientDto[];
  deliveryChannels: DeliveryChannel[];
  subject: string;
  emailBody: string;
  smsBody: string;
  isFollowUp?: boolean;
}

export interface CommunicationRecipientDto {
  id: string;
  name?: string;
  email?: string;
  phoneNumber?: string;
  isPrimary?: boolean;
  isNew?: boolean;
}

export interface CommunicationAttachmentDto {
  id: string;
  name: string;
  type: 'pdf' | 'image';
  file?: File;
  url?: string;
  size?: number;
}

export function mapDocumentTypeToCommunicationType(
  documentType: DocumentType,
  isFollowUp: boolean = false
): CommunicationType {
  switch (documentType) {
    case 'estimate':
      return isFollowUp ? 'EstimateFollowUp' : 'InitialEstimate';
    case 'invoice':
      return 'Invoice';
    case 'receipt':
      return 'Receipt';
    case 'work-order':
      return 'InitialEstimate';
    default:
      return 'InitialEstimate';
  }
}
